import { Injectable, Inject } from "@angular/core";
import { LocalData } from "./local-data";
import { RemoteData } from "./remote-data";
var CompleterService = (function () {
    function CompleterService(localDataFactory, // Using any instead of () => LocalData because on AoT errors
        remoteDataFactory // Using any instead of () => LocalData because on AoT errors
    ) {
        this.localDataFactory = localDataFactory;
        this.remoteDataFactory = remoteDataFactory; // Using any instead of () => LocalData because on AoT errors
    }
    CompleterService.prototype.local = function (data, searchFields, titleField) {
        if (searchFields === void 0) { searchFields = ""; }
        if (titleField === void 0) { titleField = ""; }
        var localData = this.localDataFactory();
        return localData
            .data(data)
            .searchFields(searchFields)
            .titleField(titleField);
    };
    CompleterService.prototype.remote = function (url, searchFields, titleField) {
        if (searchFields === void 0) { searchFields = ""; }
        if (titleField === void 0) { titleField = ""; }
        var remoteData = this.remoteDataFactory();
        return remoteData
            .remoteUrl(url)
            .searchFields(searchFields)
            .titleField(titleField);
    };
    return CompleterService;
}());
export { CompleterService };
CompleterService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
CompleterService.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: Inject, args: [LocalData,] },] },
    { type: undefined, decorators: [{ type: Inject, args: [RemoteData,] },] },
]; };
//# sourceMappingURL=completer-service.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-completer/services/completer-service.js
// module id = 126
// module chunks = 3